import { render, staticRenderFns } from "./EmbedColumn.vue?vue&type=template&id=3b4b9efa&scoped=true"
import script from "./EmbedColumn.vue?vue&type=script&lang=js"
export * from "./EmbedColumn.vue?vue&type=script&lang=js"
import style0 from "./EmbedColumn.vue?vue&type=style&index=0&id=3b4b9efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b9efa",
  null
  
)

export default component.exports